module.exports = __webpack_public_path__ + "img/idImgFront.95937da7.png";